import { createElement } from 'react';
import { fromTheme, h3, styled, hooks, webOnlyStyles } from 'lib_ui-primitives';
import {nativeOnlyProperties} from 'lib_ui-services';
const { useRouter } = hooks;

const rc = createElement;

const _Title = styled(h3).attrs(
    nativeOnlyProperties({
        numberOfLines: 1,
        ellipsizeMode: 'tail'
    })
)`
    font-family: ${fromTheme('fontAlternate')};
    color: ${fromTheme('titleBar', 'color')};
    ${fromTheme('titleBar', 'font')};
    display: block;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    margin: 0;
`;
const Title = webOnlyStyles(_Title)`
    text-overflow: ellipsis;
`;

function LayoutTitle() {
    const router = useRouter();
    const path = router.location.pathname;
    const routePieces = path.split('/');
    const currentPage = routePieces[routePieces.length - 1];

    // Continuous Scan is pushed as a route with no menu entry of its own, so the generic
    // last-path-segment fallback below would just show the raw slug ("continuous-scan").
    // Use the streamType handed off via the query string (see ContinuousScanPage.js) instead,
    // so it reads as "Count" for a physical inventory count or "Mass Update" for a mass update.
    // Router state can't be used here - useNavigation.js blocks every history.push and replays
    // it through the rules engine, which only forwards path/search, silently dropping any
    // history.push(path, state) state.
    let title = currentPage || 'Home';
    if (currentPage === 'continuous-scan') {
        const streamType = router.query.streamType;
        title = streamType === 'massUpdate' ? 'Mass Update' : 'Count';
    }

    return rc(
        Title,
        { id: 'pageTitle', role: 'heading', 'aria-level': 1, 'aria-label': title },
        title
    );
}

export default LayoutTitle;
